import { render, staticRenderFns } from "./zhuanli.vue?vue&type=template&id=2c2e098c&scoped=true&"
import script from "./zhuanli.vue?vue&type=script&lang=js&"
export * from "./zhuanli.vue?vue&type=script&lang=js&"
import style0 from "./zhuanli.vue?vue&type=style&index=0&id=2c2e098c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e098c",
  null
  
)

export default component.exports